import { Resource } from 'i18next'
import en from './en.json'
import fr from './fr.json'
import ru from './ru.json'
import es from './es.json'
import es_SV from './es_SV.json'
import { flat, unflat } from '../helpers/object'

const merge = (source: Record<string, unknown>, replacement: Record<string, unknown>) => {
  return unflat({ ...flat(source), ...flat(replacement) }) as Resource
}

export const uiResources = {
  en,
  ru,
  fr,
  es,
  es_SV,
}

export const i18nComposeWithUIComponents = appResources => merge(uiResources, appResources)
